import { render, staticRenderFns } from "./SignUpRepresentativeComponent.vue?vue&type=template&id=c9994c18&"
import script from "./SignUpRepresentativeComponent.vue?vue&type=script&lang=js&"
export * from "./SignUpRepresentativeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports